import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { JoinTypeService } from '../../../../../app/shared/API-Service/services/join-type.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Image } from '../../../../../images/images'
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-view-join-type',
  templateUrl: './view-join-type.component.html',
  styleUrls: ['./view-join-type.component.css']
})
export class ViewJoinTypeComponent implements OnInit {
  jointype:object [] = [];
  img : string = Image;
  constructor(private _JoinTypeService:JoinTypeService,private _Router:Router,private _FormBuilder:FormBuilder) { }

  ngOnInit(): void {
this.getjointype();
  }
  getjointype(){
    this._JoinTypeService.GetJoinType().subscribe((res) => {
      this.jointype = res.data
    console.log(this.jointype);
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }

  update(data){
    this._JoinTypeService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertJoinType']);
    }

    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._JoinTypeService.DeleteJoinType(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getjointype();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }
}
